import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import { TenantContext } from '../../../../context/tenant-context';
import { v2Component } from '../../../..';
import { MinimumDurationPriceConfigForm } from './minimum-duration-price-config';

export function initMinimumDurationPriceConfig(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('minimum-duration-price-form');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, productId } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <MinimumDurationPriceConfigForm productId={productId} />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
